import { cn } from '@/shared/utils'
import type { ReactNode } from 'react'
interface Props { children: ReactNode; className?: string; padding?: boolean }
export function Card({ children, className, padding=true }: Props) {
  return <div className={cn('bg-white rounded-xl border border-gray-100 shadow-sm', padding && 'p-5', className)}>{children}</div>
}
